import { render } from "./Approve.vue?vue&type=template&id=80787266"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"

import "./Approve.vue?vue&type=style&index=0&id=80787266&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "80787266"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80787266', script)) {
    api.reload('80787266', script)
  }
  
  module.hot.accept("./Approve.vue?vue&type=template&id=80787266", () => {
    api.rerender('80787266', render)
  })

}

script.__file = "src/components/Approve.vue"

export default script